import PlaceholderGraph from './PlaceholderGraph';
import PlaceholderGrid from './PlaceholderGrid';
import PlaceholderParagraph from './PlaceholderParagraph';
export default {
  Paragraph: PlaceholderParagraph,
  Grid: PlaceholderGrid,
  Graph: PlaceholderGraph
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/rsuite/es/Placeholder/Placeholder.js
// module id = 2252
// module chunks = 33